import { Spinner } from 'react-bootstrap'
import styles from './StickyTable.module.css'

type Props = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  onEndReached?: () => void
  isLoading?: boolean
}

export default function SticyTable(props: Props) {
  return (
    <div
      onScroll={(e) => {
        const target = e.target as HTMLDivElement
        const bottom =
          target.scrollHeight - target.scrollTop === target.clientHeight
        if (bottom && props.onEndReached) {
          props.onEndReached()
        }
      }}
      {...props}
      className={`position-relative table-responsive ${styles.StickyTable} ${
        props.className ?? ''
      }`}
    >
      <table className="table table-bottaro">{props.children}</table>
      {props.isLoading && (
        <div
          className="d-flex justify-content-center align-items-center position-absolute w-100 h-100"
          style={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <Spinner animation="border" role="status" variant="secondary" />
        </div>
      )}
    </div>
  )
}
